// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-45456d40\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/px2rem-loader/index.js?{\"remUnit\":75}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./personal.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("f165608a", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45456d40","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":75}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/personal.vue
// module id = IYIk
// module chunks = 1